export const SUGGESTIONS_PANEL_QUERY_PARAM = 'suggestionsPanel';
export const SUGGESTIONS_PANEL_OPEN_QUERY_VALUE = 'open';
